export default __webpack_public_path__ + "svg/calendar/2025/5/julio.svg?f43c2420";